import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { HttpClient } from '@angular/common/http';
import { getMembers, menageMember } from './member.interface';
import { environment } from 'src/environments/environment';
import { AlertService } from 'src/app/services/alert.service';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-member',
  templateUrl: './member.component.html',
  styleUrls: ['./member.component.scss']
})
export class MemberComponent {
  contentRank = environment.contentRank
  constructor(private http: HttpClient,
    private fb: FormBuilder,
    private alert: AlertService,
    private ds: DataService) {
    let ogId = sessionStorage.getItem('ogid')
    let realmid = sessionStorage.getItem('realmid')
    if (ogId == null || realmid == null) {
      window.location.replace(`${environment.replaceUrl}/check/${environment.keySystem}?system=${window.location.origin + environment.pathURL}`)
    }
    this.getMember()
  }

  formMember: FormGroup | any = this.fb.group(<menageMember>{
    Id: '',
    Fullname: '',
    Tel: '',
  })

  memberItems!: getMembers[]
  pageTotal: number = 0
  getMember(v?: any) {
    let uri: string = `member?page=${v?.page || 1}&limit=15`
    if (v?.value) {
      uri = `member?search=${Number(v.value)}&page=${v?.page || 1}&limit=15`
    }
    this.http.get(uri).subscribe({
      next: (res: any) => {
        this.memberItems = res.data;
        this.pageTotal = res.pageTotal;
      }
    })
  }



  message: string = ""
  manageMember: boolean = false
  addStatus: boolean = false;
  addMember() {
    this.message = "เพิ่มสมาชิก"
    this.manageMember = true
    this.addStatus = true;
  }

  createMember() {
    this.formMember.get('Tel').setValue(Number(this.formMember.value.Tel))
    this.http.post(`member`, this.formMember.value).subscribe({
      next: (res: any) => {
        this.alert.notify(res.message, 'success')
        this.getMember()
        this.clearEvent();
      },
      error: (err) => {
        this.alert.dialog(err.error.message)
      },
      complete: () => {
        this.getMember()
      }
    })
  }


  clearEvent() {
    this.formMember.reset()
    this.message = ""
    this.addStatus = false;
    this.manageMember = false;
  }
}


